import React from 'react'

export const Login = () => {
    return (
        <>
            <style>
                {`  
                    .Login {
                        height: 100vh;

                    }
                `}
            </style>
            <div className="Login">
                Log In
            </div>
        </>
    )
}

